import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import RouteTrackingComponent from "../Routes/RouteTracking";

export default function SchoolRouteMonitor() {
  const { routeId } = useParams();
  const location = useLocation();

  const routeData = useMemo(() => {
    if (location.state?.selectedRouteData) {
      return location.state.selectedRouteData;
    }

    try {
      const storedRoute = localStorage.getItem(`schoolRouteMonitor:${routeId}`);
      return storedRoute ? JSON.parse(storedRoute) : null;
    } catch (error) {
      console.error("Error reading school route monitor data:", error);
      return null;
    }
  }, [location.state, routeId]);

  return (
    <RouteTrackingComponent
      routeData={routeData}
      isSchoolMonitor={true}
    />
  );
}